
import React from "react";
import { tariffs } from "./tariff.constants";
import { TariffCard } from "./TariffCard";
import { useIsMobile } from '@/hooks/use-mobile';

interface TariffCardsGridProps {
  selected: string | null;
  setSelected: (key: string) => void;
  isMobile?: boolean;
}

export const TariffCardsGrid: React.FC<TariffCardsGridProps> = ({
  selected, setSelected, isMobile: propIsMobile,
}) => {
  // Используем хук для определения мобильного устройства, если prop не передан
  const hookIsMobile = useIsMobile();
  const isMobile = propIsMobile !== undefined ? propIsMobile : hookIsMobile;
  
  return (
    <div
      className={`
        relative w-full gap-4 
        grid
        ${isMobile ? "grid-cols-1" : "grid-cols-2"}
        justify-center items-stretch max-w-[900px] mx-auto
        py-4 sm:py-6 px-2
      `}
      style={{ 
        maxHeight: isMobile ? "calc(100vh - 180px)" : "auto", 
        overflowY: isMobile ? "auto" : "visible",
        paddingBottom: isMobile ? "120px" : "2rem"
      }}
    >
      {tariffs.map((tariff) => (
        <TariffCard
          key={tariff.key}
          tariff={tariff}
          active={selected === tariff.key}
          onSelect={() => setSelected(tariff.key)}
        />
      ))}
    </div>
  );
};
